// react-table depends on spreading props; we could name them explicitly but this component might
// break if the shape of the return value from row.getRowProps() changes
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Cell, Row } from 'react-table';
import { WorkNameCell } from '.';

interface PlaceholderWorkNameCellProps {
    cell: Cell<TrqkGapChannelAudio, GapWorkNameCellValue>;
    column: StatementWorkColumn;
    row: Row<TrqkGapChannelAudio>;
}

/**
 * Renders a <WorkNameCell /> without an icon.
 * @param props - {@link PlaceholderWorkNameCellProps}
 * @returns JSX
 */
export function PlaceholderWorkNameCell({
    cell,
    column,
}: PlaceholderWorkNameCellProps): JSX.Element {
    return <WorkNameCell cell={cell} column={column} showIcon={false} />;
}
